import { LeaveAreaCode, PermissionCode, type LeaveSwitchableArea } from '@gb-ticket/shared-types';
import { Outlet } from 'react-router';

import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { OverflowTabNav } from '@/platform/components/overflow-tab-nav';
import { leaveAreaEnabled, useLeaveAreas } from '@/products/leave/features/use-leave-areas';
import {
  LEAVE_ADMIN_BALANCES_PATH,
  LEAVE_ADMIN_CAPACITY_PATH,
  LEAVE_ADMIN_EXPORT_PATH,
  LEAVE_ADMIN_HOLIDAYS_PATH,
  LEAVE_ADMIN_PATH,
  LEAVE_ADMIN_POLICY_PATH,
  LEAVE_ADMIN_TYPES_PATH,
} from '@/products/leave/leave-paths';

const LINKS: {
  to: string;
  label: string;
  permission: (typeof PermissionCode)[keyof typeof PermissionCode];
  end?: boolean;
  area?: LeaveSwitchableArea;
}[] = [
  {
    to: LEAVE_ADMIN_PATH,
    label: 'Übersicht',
    permission: PermissionCode.LEAVE_POLICY_MANAGE,
    end: true as const,
  },
  {
    to: LEAVE_ADMIN_POLICY_PATH,
    label: 'Richtlinie',
    permission: PermissionCode.LEAVE_POLICY_MANAGE,
  },
  {
    to: LEAVE_ADMIN_HOLIDAYS_PATH,
    label: 'Feiertage',
    permission: PermissionCode.LEAVE_POLICY_MANAGE,
  },
  {
    to: LEAVE_ADMIN_TYPES_PATH,
    label: 'Arten',
    permission: PermissionCode.LEAVE_POLICY_MANAGE,
  },
  {
    to: LEAVE_ADMIN_BALANCES_PATH,
    label: 'Salden',
    permission: PermissionCode.LEAVE_BALANCES_ADJUST,
  },
  {
    to: LEAVE_ADMIN_CAPACITY_PATH,
    label: 'Besetzung',
    permission: PermissionCode.LEAVE_POLICY_MANAGE,
    area: LeaveAreaCode.CAPACITY,
  },
  {
    to: LEAVE_ADMIN_EXPORT_PATH,
    label: 'Export',
    permission: PermissionCode.LEAVE_REPORTS_EXPORT,
    area: LeaveAreaCode.EXPORT,
  },
];

export function LeaveAdminLayout() {
  const me = useMe();
  const areas = useLeaveAreas();
  const items = LINKS.filter(
    (link) =>
      hasPermission(me.data, link.permission) &&
      (link.area == null || leaveAreaEnabled(areas.data, link.area) !== false),
  ).map(({ to, label, end }) => ({ to, label, end }));

  return (
    <div className="min-w-0 space-y-6">
      <OverflowTabNav ariaLabel="HR-Verwaltung" items={items} />
      <Outlet />
    </div>
  );
}
